import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { getLocalDateOnly } from '../../utils/local_date';

export function generateItemLocation(app, params) {
  const service = common.getAccountService(app, 'mass-location-item/generate');
  return service.create(null, params, false, { timeout: 0 });
}

export function fetchLocationDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'location/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };
  return common.getDropdownList(app, { query });
}

export function deleteLocation(app, params) {
  const { id } = params;
  const docType = DocType.LOCATION;
  return common.deleteDoc(app, { id, docType });
}


export function saveLocation(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const parentLocId = (data.location_type_id !== 'store') ? util.toObjectId(data.parent_id) : null;
  const isPhysicalLocation = (data.location_type_id !== 'store') ? data.is_physical_location : true;
  const operations = {
    ...(data.operations || {}),
    exception: ((data.operations || {}).exception || []).map((e) => {
      if (e.date) {
        e.date = getLocalDateOnly(e.date);
      }
      return e;
    }),
  };
  let locationData = {
    doc_type: DocType.LOCATION,
    name: util.toStringText(data.name),
    subsidiary_id: data.subsidiary_id,
    currency_id: data.currency_id,
    price_group_id: data.price_group_id,
    parent: parentLocId,
    timezone: util.toStringText(data.timezone),
    region_id: data.region_id,
    location_type_id: data.location_type_id,
    available_to_ship: util.toBoolean(data.available_to_ship),
    available_for_pickup: util.toBoolean(data.available_for_pickup),
    available_on_web: util.toBoolean(data.available_on_web),
    address_details: util.toObjectArray(data.address_details),
    contacts: util.toObjectArray(data.contacts),
    active: util.toBoolean(data.active),
    is_physical_location: isPhysicalLocation,
    custom_fields: data.custom_fields,
    order_ranking: util.toInteger(data.order_ranking),
    safety_stock: data.safety_stock,
    order_group_id: data.order_group_id,
    operations,
    shipping_methods: util.toObjectIds(
      data.shipping_methods,
      data.shipping_method_ids,
      'shipping_method_id',
    ),
  };
  const isStore = data.location_type_id === 'store';
  if (!data.id && isStore) {
    const subLocation = {
      return: { name: data.return_mapped_location_type, is_physical: (data.return_is_physical_location) ? true : false },
      layby: { name: data.layby_mapped_location_type, is_physical: (data.layby_is_physical_location) ? true : false },
      deposit: { name: data.deposit_mapped_location_type, is_physical: (data.deposit_is_physical_location) ? true : false },
      disposal: { name: data.disposal_mapped_location_type, is_physical: (data.disposal_is_physical_location) ? true : false },
      shipping: { name: data.shipping_mapped_location_type, is_physical: (data.shipping_is_physical_location) ? true : false },
      pickup: { name: data.pickup_mapped_location_type, is_physical: (data.pickup_is_physical_location) ? true : false },
      preorder: { name: data.preorder_mapped_location_type, is_physical: (data.preorder_is_physical_location) ? true : false },
      reserved: { name: data.reserved_mapped_location_type, is_physical: (data.reserved_is_physical_location) ? true : false }
    }
    locationData.sublocation = subLocation;
    locationData.is_sub_location = false;
  }

  if (data.id && isStore) {
    const { sub_location_mapping } = data;
    locationData.sub_location_mapping = {
      id: sub_location_mapping.id,
      return_id: sub_location_mapping.return.id,
      layby_id: sub_location_mapping.layby.id,
      deposit_id: sub_location_mapping.deposit.id,
      disposal_id: sub_location_mapping.disposal.id,
      shipping_id: sub_location_mapping.shipping.id,
      pickup_id: sub_location_mapping.pickup.id,
      preorder_id: sub_location_mapping.preorder.id,
      reserved_id: sub_location_mapping.reserved.id,
    };
  }

  return common.saveDoc(app, {
    source: data,
    doc: locationData,
    user,
  });
}



export async function fetchLocationById(app, params) {
  const { id, path } = params;
  const docType = DocType.LOCATION;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });

  return util.filterCustomFieldsByViewMode(doc, path);
}



export function fetchSubLocationsByParentId(app, params) {
  const { id } = params;
  const service = common.getAccountService(app, DocType.LOCATION);
  const options = {
    selector: {
      doc_type: DocType.LOCATION,
      parent: { _id: id }
    },
    limit: 10000,
    // profile: app.get('user_info')
  }
  return service.find({ query: options }).then(util.convertDocIds);
}
